import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProjectActivity} from '../../project-misc/data/project/activity/project-activity';

@JsonObject('model.activity.LogisticDay')
export class LogisticDay extends AbstractModel {

  @JsonProperty(String, 'title')
  title: string;

  @JsonProperty([ProjectActivity], 'activities')
  activities: ProjectActivity[]
}
